import { connect } from "react-redux";
import { getListQuanLyThuChiHopDong } from "../../actions/QuanLyThuChiHopDong";
import { QuanLyThuChiHopDong } from "../../components/QuanLyThuChi/ThuChiHopDong";

const mapStateToProps = (state) => ({
  inthuchi: state.inthuchi,
});

const mapDispatchToProps = (dispatch) => ({
  getListQuanLyThuChiHopDong: (dataSearch) =>
    dispatch(getListQuanLyThuChiHopDong(dataSearch)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuanLyThuChiHopDong);
